export const handleInputValue = (type: string, value: any) =>
  type === "checkbox"
    ? value === "1"
      ? 0
      : 1
    : type === "number"
      ? Number(value)
      : value;
